var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#47A7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#551BFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66663 10.9783V17.0217C9.66663 17.4825 10.1741 17.7625 10.565 17.5117L15.3133 14.49C15.675 14.2625 15.675 13.7375 15.3133 13.5042L10.565 10.4883C10.1741 10.2375 9.66663 10.5175 9.66663 10.9783Z",
    fill: "#551BFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V0L21 6H17C15.8954 6 15 5.10457 15 4Z",
    fill: "#551BFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/Media.67b5bbc9166677134746801eedd3c6cb.svg";
export { ForwardRef as ReactComponent };